import {
  APP_V2_APP_EVENTS,
  APP_V2_USER_EVENTS,
  logError,
  logEvent,
} from "@src/appV2/lib/analytics";
import { useLocalStorage } from "@src/appV2/lib/utils/useLocalstorage";
import { useUpdatePayoutSettings } from "@src/appV2/redesign/Accounts/PayoutSettings/api/useUpdatePayoutSettings";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useToast } from "../../../../../../lib";
import { getSuggestInstantPayStorageKey, type SuggestInstantPayDismissalState } from "../types";

export function useSuggestInstantPayActions() {
  const { userId } = useDefinedWorker();

  const { showSuccessToast } = useToast();

  const [, setDismissalState] = useLocalStorage<SuggestInstantPayDismissalState>(
    getSuggestInstantPayStorageKey(userId),
    {}
  );

  const { mutateAsync: updatePayoutSettings, isLoading: isSwitchingToInstantPay } =
    useUpdatePayoutSettings();

  function handleDismiss(dontAskAgain: boolean) {
    setDismissalState((previous) => ({
      ...previous,
      lastDismissedAt: new Date().toISOString(),
      permanentlyDismissed: dontAskAgain,
    }));
  }

  async function handleSwitchToInstantPay(): Promise<boolean> {
    try {
      await updatePayoutSettings({ payoutSchedule: "instant" });
      logEvent(APP_V2_USER_EVENTS.SUGGEST_INSTANT_PAY_SWITCH_SUCCESS);
      showSuccessToast("You're all set! Payouts will arrive within 30 minutes after clocking out.");
      handleDismiss(false);
      return true;
    } catch (error) {
      logError(APP_V2_APP_EVENTS.SUGGEST_INSTANT_PAY_SWITCH_FAILURE, {
        error,
      });
      return false;
    }
  }

  return {
    handleDismiss,
    handleSwitchToInstantPay,
    isSwitchingToInstantPay,
  };
}
